/**
 * Start a file download from a short-lived signed URL without leaving the page.
 * The URL answers with Content-Disposition: attachment, so a hidden iframe saves the file;
 * an error response (expired link, missing object) renders inside the hidden frame instead
 * of replacing the map.
 */
export function triggerPdfDownload(url, doc = typeof document !== 'undefined' ? document : null) {
  if (!url || !doc) return false;
  const frame = doc.createElement('iframe');
  frame.style.display = 'none';
  frame.setAttribute('aria-hidden', 'true');
  frame.src = url;
  doc.body.appendChild(frame);
  setTimeout(() => frame.remove(), 60_000);
  return true;
}
